import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    ${media.mobileDevice`
        width:100%;
        position: fixed;
        top: 3.6rem;
        background-color:yellow;
        z-index: 2000;
        margin:0;
        padding:250px;
    `}
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    padding: 6px 0;
    /* padding-top: 10px;
    padding-bottom: 25px; */
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '5px')};
    width: 100%;
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    //font:15px Avenir Next World;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;

    ${media.mobileDevice`
        margin-bottom:15px ;
        /* padding-bottom: 30px; */
        padding: 0;
        // extra space removed b/w tissue service label and shipping details
        margin-top: 0px;
        // grey color applied from edge to edge
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
    `};
`;

export const BoxView = styled.div`
    border-radius: ${(props) => (props.bRadius ? props.bRadius : '3px')};
    margin-right: ${(props) => (props.mr ? props.mr : '2px')};
    margin-left: ${(props) => (props.ml ? props.ml : '2px')};
    margin-top: ${(props) => props.mTop};
    background-color: ${(props) => (props.bgColor ? props.bgColor : '#C2F1FD')};
    border: ${(props) =>
        props.bgBorder ? props.bgBorder : ' 1px solid #4b99ad'};
    height: ${(props) => (props.scrHeight ? props.scrHeight : ' 18px')};
    width: ${(props) => props.scrWidth};
    padding: ${(props) => (props.boxpadding ? props.boxpadding : '0px 4px')};
    display: flex;
    justify-content: ${(props) => (props.jContent ? props.jContent : 'center')};
    align-items: ${(props) => (props.aConetnt ? props.aConetnt : 'center')};
    ${media.mobileDevice`
    margin-right: ${(props) => (props.mbr ? props.MobMr : '2px')};
    `};
`;

export const ErrorMessageDiv = styled.div`
    margin: 10px 5px 10px 0;
`;
export const ErrorMessageRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;

export const ErrorTitlerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ImageTag = styled.img`
    position: ${({ position }) => (position ? position : 'unset')};
    top: ${({ top }) => (top ? top : 'unset')};
    right: ${({ right }) => (right ? right : 'unset')};
    cursor: ${({ cursor }) => (cursor ? cursor : 'unset')};
    margin: ${({ margin }) => (margin ? margin : 'unset')};
`;

export const AlertCircleOutlineImg = styled.img`
    height: ${props => props.height || '16px'};
    width: ${props => props.width || '16px'};
    margin: ${props => props.margin || '2px 6px 0 0'};
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 12px 0px')};
    padding: ${({ padding }) => (padding ? padding : '20px 24px')};
    position: relative;
    width: cal(100%-20px);
    border-radius: 6px;
    box-shadow: ${({ boxShadow }) => (boxShadow ? boxShadow : '0px 0px 6px #00000029')};
    background: ${({ background }) => (background ? background : '#ffffff 0% 0% no-repeat padding-box')};
    ${media.mobileDevice`
        box-shadow: 0px 0px 6px #00000029;
        background: #ffffff 0% 0% no-repeat padding-box;
        margin: ${({ marginMb }) => (marginMb ? marginMb : '0px 0px 18px 0px')};
    
    `};
`;